<template>
    <div class="clearfix leave-attendance-wrapper">

        <div class="row col-12 mb-3 top pr-0" v-if="!is_profile">
            <div class="col-md-10 pl-0" v-if="employee_id > 0">
                <employee-public-info :hidebacknext="true" :pageurl="$api_url" :key="componentKey"></employee-public-info>
            </div>
            <div class="col-md-2 select-employee pr-0"><b-button variant="btn btn-primary" @click="showSerch()">Select Employee</b-button></div>
        </div>

        <div class="row col-12 no-margin leave-summery px-0" v-if="employee_id > 0">
            <div class="col-md-4 pl-0">
               <!-- /* Abdullah after live leave-attendence-summary-box*/ -->
                <div class="ibox col-md-12 leave-attendence-summary-box">
                    <div class="ibox-title dashboard_title">
                        <span class="text-center">Leave Summary</span>
                    </div>
                    <div class="row leave-summery-count">
                        <div class="col-md-6 doughnut-leave">

                            <template v-if="doughnutDatas != null">
                                <doughnut-chart :chart-data="doughnutDatas" :options= "options_doughnut" :styles="myStyles_doughnut"  class="doughnut-wrapper pb-2"></doughnut-chart>
                            </template>

                            <div class="doughnut-leave-data">
                            <div class="count">
                                <span class="first">
                                    <template v-if="leave_attendance_report.approved_leaves != undefined">{{ leave_attendance_report.approved_leaves }}</template>
                                    <template v-else>0</template>
                                </span>
                                <span class="second">
                                    /
                                </span>
                                <span class="third">
                                    <template v-if="leave_attendance_report.allowed_leaves != undefined">{{ leave_attendance_report.allowed_leaves }}</template>
                                    <template v-else>0</template>
                                </span>
                            </div>
                            <div class="text">Leaves Taken</div>
                            </div>

                        </div>
                        <div class="col-md-6 d-flex align-items-center">
                            <div class="btn btn-primary cursor-pointer leave-button" @click="addLeave()">Apply Leave</div>
                        </div>
                    </div>


                </div>

            </div>
            <div class="col-md-8 px-0">
                 <!-- /* Abdullah after live leave-attendence-summary-box*/ -->
                <div class="ibox col-md-12 leave-attendence-summary-box">
                    <div class="ibox-title dashboard_title">
                        <span class="text-center">Attendance Summary</span>
                    </div>
                    <div class="attendance-summery">
                        <div class="row wrapper">
                            <div class="col-4 pr-0">
                                <div class="clearfix col-md-12 box-content conteiner">
                                    <div class="conteiner-1">
                                        <div class="text">Days Absent</div>
                                        <template v-if="leave_attendance_report.absent != undefined">
                                            <div class="value">{{ leave_attendance_report.absent }}</div>
                                        </template>
                                        <template v-else>
                                            <div class="value">0</div>
                                        </template>
                                    </div>
                                    <div class="conteiner-2">
                                        <img :src="$api_url+'/images/attendance-summery-1.png'"  class="" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 pr-0">
                                <div class="clearfix  col-md-12 box-content conteiner">
                                    <div class="conteiner-1">
                                        <div class="text">Days Late</div>
                                        <template v-if="leave_attendance_report.total_late_check_in != undefined">
                                            <div class="value">{{ leave_attendance_report.total_late_check_in }}</div>
                                        </template>
                                        <template v-else>
                                            <div class="value">0</div>
                                        </template>

                                    </div>
                                    <div class="conteiner-2">
                                        <img :src="$api_url+'/images/attendance-summery-2.png'"  class="" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 pr-0">
                                <div class="clearfix  col-md-12 box-content conteiner">
                                    <div class="conteiner-1">
                                        <div class="text">Days Left Early</div>
                                        <template v-if="leave_attendance_report.total_early_checkout != undefined">
                                            <div class="value">{{ leave_attendance_report.total_early_checkout }}</div>

                                        </template>
                                        <template v-else>
                                            <div class="value">0</div>
                                        </template>
                                    </div>
                                    <div class="clearfix  conteiner-2">
                                        <img :src="$api_url+'/images/attendance-summery-3.png'"  class="" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="leave-attendance-front-container" v-if="employee_id > 0">
            <div class="attendance-log">
                <div class="row no-gutters mb-3 reports-tab-nav">
                    <div class="col-sm-12 company-form-box-title pb-3">Attendance Log</div>
                        <div class="col-sm-9">
                            <v-calendar   is-expanded :columns="2" :masks="masks" :attributes="attributes" :first-day-of-week="first_day_of_week" ref="trzcalendar"
                                class='v-calendar '  @update:to-page="monthDetailsNew" :from-page="page">

                                <template slot="day-content" class='vc-w-full vc-relative' slot-scope='{day, dayEvents, attributes, attributesMap , popover}'>
                                    <template v-if="this_month_holidays[day.id] == undefined">
                                        <div class="vc-day-content">
                                            <div class="flex flex-column h-100 overflow-hidden">
                                                <div class="day-label text-sm text-gray-900" >{{day.day}}</div>
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <template v-if="this_month_holidays[day.id].status == 'weekend'">
                                            <div :class='"vc-day-content " + this_month_holidays[day.id].status' :style="{'color':this_month_holidays[day.id].color}">
                                                <div  v-if="this_month_holidays[day.id]" :title="this_month_holidays[day.id].title">
                                                    <div class="flex flex-column overflow-hidden" >

                                                        {{day.day}}

                                                    </div>
                                                </div>
                                                <div  v-else>
                                                    <div class="flex flex-column h-100 overflow-hidden">
                                                        <div class="day-label text-sm text-gray-900" >{{day.day}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div :class='"vc-day-content " + this_month_holidays[day.id].status'  :style="{'background-color':this_month_holidays[day.id].color}">
                                                <div  v-if="this_month_holidays[day.id]" :title="this_month_holidays[day.id].title">
                                                    <div class="flex flex-column overflow-hidden" >

                                                        {{day.day}}

                                                    </div>
                                                </div>
                                                <div  v-else>
                                                    <div class="flex flex-column h-100 overflow-hidden">
                                                        <div class="day-label text-sm text-gray-900" >{{day.day}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </template>



                                </template>
                            </v-calendar>

                        </div>

                        <!-- Abdullah 14-05-26 added css and chnaged the colors to scroll view as per Ashik vai's suggestion -->
                        <div class="col-sm-3">
                            <div class="legend" style="border: 1px solid rgb(118, 201, 211); border-radius: 12px; padding: 12px; max-height: 273px; overflow-y: auto; margin-left: 34px; margin-right: 40px;">
                                <div class="row trz_borders mx-0">
                                    <div class="col-sm-12"><div class="mark current"></div><div class="text">Current</div></div>
                                    <div class="col-sm-12"><div class="mark absent"></div><div class="text">Absent</div></div>
                                    <div class="col-sm-12"><div class="mark present"></div><div class="text">Present</div></div>
                                    <!-- Abdullah: 12-05-2026 -->
                                    <div class="col-sm-12"><div class="mark" :style="'background:'+holiday_color_code"></div><div class="text">Holiday</div></div>
                                    <div class="col-sm-12"><div class="mark" :style="'background:'+weekend_color_code"></div><div class="text">Weekend</div></div>
                                    <!-- Abdullah: 12-05-2026 -->
                                    <div class="col-sm-12"><div class="mark late"></div><div class="text">Late</div></div>
                                    <div class="col-sm-12"><div class="mark left-early"></div><div class="text">Left Early</div></div>
                                    <template v-for="leavetype in leavetypes">
                                        <div class="col-sm-12">
                                            <div class="mark" v-bind:style="'background:'+leavetype.color_code"></div><div class="text">{{leavetype.title}}</div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>

                         <!-- Abdullah 14-05-26 added css and chnaged the colors to scroll view as per Ashik vai's suggestion END -->

                </div>
                <div class="row no-gutters mb-3">
                    <div class="col-sm-12 company-form-box-title pb-3">
                        Leave Log
                    </div>
                    <div class="col-md-12 leave-log-wrapper">
                        <leaves :pageurl="$api_url" :flg="1" :key="componentKey"></leaves>
                    </div>
                </div>
            </div>
        </div>

        <b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
            <search-employees :pageurl="$api_url" :flg="1" v-on:childToParent="helloFars"></search-employees>
        </b-modal>

          <b-modal id="attendance_edit_Modal" size="lg" scrollable  hide-footer title="Attendence Info">
            <div class="row " v-if="ce">
                <div class="col-sm-4 d-none" >
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-form-group id="attendances_date-group" label="Attendances Date" label-for="attendances_date">
                            <b-form-datepicker id="attendances_date" :readonly="true" :max="max" :min="min" v-model="fdata.attendances_date" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker>
                        </b-form-group>


                        <b-form-group id="absent-group" label-for="absent" >
                            <b-form-checkbox id="absent" v-model="fdata.absent" name="absent" value="1" unchecked-value="0">
                                Absent
                            </b-form-checkbox>
                        </b-form-group>

                        <b-form-group id="check_in-group" label="Check In" label-for="check_in" v-if="fdata.absent == 0">
                            <template>
                            <b-form-timepicker id="check_in" name="check_in" v-model="fdata.check_in" now-button reset-button locale="en"></b-form-timepicker>
                            </template>
                        </b-form-group>

                        <b-form-group id="checkout-group" label="Checkout" label-for="checkout"  v-if="fdata.absent == 0">
                            <template>
                            <b-form-timepicker id="checkout" name="checkout" v-model="fdata.checkout" now-button reset-button locale="en"></b-form-timepicker>
                            </template>
                        </b-form-group>

                        <b-form-group id="comment-group" label="Reason/Comment" label-for="comment">
                            <b-form-textarea id="comment" name="comment" rows="3" max-rows="6" no-resize v-model="fdata.comment"  v-validate="{required: true, min: 3 }" :state="validateState('comment')" aria-describedby="comment-feedback" data-vv-as="Reason/Comment"></b-form-textarea>
                            <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment') }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-button type="submit" variant="primary">Submit</b-button>
                    </b-form>
                </div>
                <div class="col-sm-12 " v-if="fdata.work_time > 0">
                    <div class="row no-margin">
                        <div class="col-md-6">

                            <div class="card punch-status">
                                <div class="card-body">
                                    <h5 class="card-title">Timesheet <small class="text-muted">{{fdata.attendances_date}}</small></h5>
                                    <div class="punch-det">
                                        <h6>Punch In at</h6>
                                        <p>{{fdata.check_in}}</p>
                                    </div>
                                    <div class="punch-info">
                                        <div class="punch-hours">
                                            <span>{{this.convertMinsToHrsMins(fdata.work_time)}} hrs</span>
                                        </div>
                                    </div>
                                    <div class="punch-det">
                                        <h6>Punch Out at</h6>
                                        <p>{{fdata.checkout}}</p>
                                    </div>
                                    <div class="statistics">
                                        <div class="row">
                                            <div class="col-md-6 col-6 text-center">
                                                <div class="stats-box">
                                                    <p>Break</p>
                                                    <h6>{{this.convertMinsToHrsMins(fdata.break_time)}} hrs</h6>
                                                </div>
                                            </div>
                                            <!-- commented out by faroque -->
                                            <!--<div class="col-md-12 col-12 text-center">
                                                <div class="stats-box">
                                                    <p>Overtime</p>
                                                    <h6>{{over_time}} hrs</h6>
                                                </div>
                                            </div>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card recent-activity">
                                <div class="card-body">
                                    <h5 class="card-title">Activity</h5>
                                    <ul class="res-activity-list" v-if="fdata.activity_log">
                                        <li v-for="(activity, index) in fdata.activity_log.split(',')">
                                            <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                                            <p class="mb-0" v-else>Punch Out at</p>
                                            <p class="res-activity-time">
                                                <i class="far fa-clock"></i>
                                                {{formateMe(activity) }}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 " v-else>
                Can not submit attendance for an ex employee.
            </div>
        </b-modal>

         <b-modal id="bv-modal-add-leave-profile" size="xl" scrollable  hide-footer title="Leave Details" dialog-class="w-1500">
            <employee-leave-details v-if="this.employee_id > 0" :pageurl="$api_url" :editflg="0"  v-on:childToParent="reloadMe"></employee-leave-details>
        </b-modal>

        <!-- <div class="" v-if="!is_profile">
            <h5 class="mb-3 mt-5 border-bottom pb-3">Attendance and Leave Log <template v-if="employee_id > 0">from {{start_date}} to {{end_date}}</template></h5>
            <div class="row">
                <div class="col-sm-6">
                    <div class="custom-search">

                        <b-button variant="btn btn-secondary" @click="showSerch()">Select Employee</b-button>
                    </div>
                </div>
            </div>
        </div> -->
        <!-- <div class="card-body px-0" v-if="employee_id > 0"> -->
            <!-- <ul class="list-group mb-3 " v-if='errormsg'>
                <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
            </ul>
            {{successmsg}} -->

            <!-- <employee-public-info v-if="!is_profile" :key="componentKey"></employee-public-info> -->


            <!-- <div class="row mt-5 leave-att-summery">
                <div class="col-md-6">
                    <h5 class="mb-3 border-bottom pb-3">Leave Summary</h5>
                    <div class="card no-shadow">
                        <div class="card-body">
                            <div class="time-list">
                                <div class="dash-stats-list">
                                    <h4>{{leave_attendance_report['approved_leaves']}}</h4>
                                    <p>Leave Taken</p>
                                </div>
                                <div class="dash-stats-list">
                                    <h4>{{leave_attendance_report['remaining_leaves']}}</h4>
                                    <p>Remaining</p>
                                </div>
                                <div class="dash-stats-list">
                                    <h4>{{leave_attendance_report['carried_leaves']}}</h4>
                                    <p>Carried Leaves</p>
                                </div>
                            </div>
                            <div class="request-btn">
                                <div class="dash-stats-list">
                                    <div class="btn btn-primary cursor-pointer" @click="addLeave()">Apply Leave</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <h5 class="mb-3 border-bottom pb-3">Attendance Summary</h5>
                    <div class="card no-shadow">
                        <div class="card-body">
                            <div class="time-list">
                                <div class="dash-stats-list">
                                    <h4>{{leave_attendance_report['absent']}}</h4>
                                    <p>Days Absent</p>
                                </div>
                                <div class="dash-stats-list">
                                    <h4>{{leave_attendance_report['total_late_check_in']}}</h4>
                                    <p>Days Late</p>
                                </div>
                            </div>
                            <div class="request-btn">
                                <div class="dash-stats-list">
                                    <h4>{{leave_attendance_report['total_early_checkout']}}</h4>
                                    <p>Days Left Early</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- <div class="mt-4 employee-tab">
                <b-tabs pills content-class="" nav-class=" pr-2 m-2" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">
                    <template >
                       <b-tab lazy>
                            <template active v-slot:title>Attendance</template>
                            <div class="card clearfix">
                                <div class="card-body">

                                    <div class="row  ">
                                        <div class="col-sm-12 ">
                                            <v-calendar is-expanded  :masks="masks" :attributes="attributes" :first-day-of-week="first_day_of_week" ref="trzcalendar"
                                                class='v-calendar '   @update:to-page="monthDetails" :from-page="page">
                                                <template slot="day-content" class='vc-w-full vc-relative' slot-scope='{day, dayEvents, attributes, attributesMap , popover}'>
                                                    <div v-bind:class='{"holiday": weekly_holidays.includes(day.weekday)}'>
                                                        <div v-if="this_month_holidays[day.id]" :style="{background: `linear-gradient(90deg, ${this_month_holidays[day.id].color[0]} 50%, ${this_month_holidays[day.id].color.length > 1 ? this_month_holidays[day.id].color[1] : this_month_holidays[day.id].color[0]} 50%)`}" :title="this_month_holidays[day.id].title">
                                                            <div class="flex flex-column h-100 overflow-hidden">

                                                                <div class="day-label text-sm text-gray-900 cursor-pointer" v-if="((this_month_holidays[day.id].status == 'work'))" @click="loadAttendance(day.id , this_month_holidays[day.id])">

                                                                    {{day.day}}</div>
                                                                <div class="day-label text-sm text-gray-900 " v-else>{{day.day}}</div>

                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="flex flex-column h-100 overflow-hidden">
                                                                <div class="day-label text-sm text-gray-900" >{{day.day}}</div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </template>
                                            </v-calendar>

                                            <div class="legend mt-4">
                                                <div class="row trz_borders">
                                                    <div class="col-sm-2 " style="background:#38c172">Present</div>
                                                    <div class="col-sm-2 bg-danger">Absent</div>
                                                    <div class="col-sm-2  " v-bind:style="'background:'+weekend_color_code">Weekend</div>
                                                    <div class="col-sm-2 " v-bind:style="'background:'+holiday_color_code">Holiday</div>
                                                    <div class="col-sm-2 " style="background:#FFD300">Late</div>
                                                    <template v-for="leavetype in leavetypes">
                                                        <div class="col-sm-2 " v-bind:style="'background:'+leavetype.color_code">{{leavetype.title}}</div>
                                                    </template>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab lazy>
                            <template active v-slot:title>Leaves</template>

                            <leaves  :flg="1" :key="componentKey"></leaves>
                        </b-tab>


			            <b-tab lazy>
                            <template active v-slot:title>Geo Locations</template>
                            <div class="card clearfix">
                                <div class="card-body">
                                    <map-geolocations  :flg="1" :key="componentKey"></map-geolocations>
                                </div>
                            </div>
                        </b-tab>



                    </template>
                </b-tabs>
            </div> -->
        <!-- </div> -->
        <!-- <b-modal id="bv-modal-employeesearch" size="lg" hide-footer title="Search Employees">
            <SearchEmployees  :flg="1" v-on:childToParent="helloFars"></SearchEmployees>
        </b-modal>
         -->


        <!-- <b-modal id="attendance_edit_Modal" size="lg" scrollable  hide-footer title="Attendence Info">
            <div class="row " v-if="ce">
                <div class="col-sm-4 d-none" >
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-form-group id="attendances_date-group" label="Attendances Date" label-for="attendances_date">
                            <b-form-datepicker id="attendances_date" :readonly="true" :max="max" :min="min" v-model="fdata.attendances_date" :date-disabled-fn="dateDisabled" :start-weekday="fetchStartWeekday"></b-form-datepicker>
                        </b-form-group>


                        <b-form-group id="absent-group" label-for="absent" >
                            <b-form-checkbox id="absent" v-model="fdata.absent" name="absent" value="1" unchecked-value="0">
                                Absent
                            </b-form-checkbox>
                        </b-form-group>

                        <b-form-group id="check_in-group" label="Check In" label-for="check_in" v-if="fdata.absent == 0">
                            <template>
                            <b-form-timepicker id="check_in" name="check_in" v-model="fdata.check_in" now-button reset-button locale="en"></b-form-timepicker>
                            </template>
                        </b-form-group>

                        <b-form-group id="checkout-group" label="Checkout" label-for="checkout"  v-if="fdata.absent == 0">
                            <template>
                            <b-form-timepicker id="checkout" name="checkout" v-model="fdata.checkout" now-button reset-button locale="en"></b-form-timepicker>
                            </template>
                        </b-form-group>

                        <b-form-group id="comment-group" label="Reason/Comment" label-for="comment">
                            <b-form-textarea id="comment" name="comment" rows="3" max-rows="6" no-resize v-model="fdata.comment"  v-validate="{required: true, min: 3 }" :state="validateState('comment')" aria-describedby="comment-feedback" data-vv-as="Reason/Comment"></b-form-textarea>
                            <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment') }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-button type="submit" variant="primary">Submit</b-button>
                    </b-form>
                </div>
                <div class="col-sm-12 " v-if="fdata.work_time > 0">
                    <div class="row no-margin">
                        <div class="col-md-6">

                            <div class="card punch-status">
                                <div class="card-body">
                                    <h5 class="card-title">Timesheet <small class="text-muted">{{fdata.attendances_date}}</small></h5>
                                    <div class="punch-det">
                                        <h6>Punch In at</h6>
                                        <p>{{fdata.check_in}}</p>
                                    </div>
                                    <div class="punch-info">
                                        <div class="punch-hours">
                                            <span>{{this.convertMinsToHrsMins(fdata.work_time)}} hrs</span>
                                        </div>
                                    </div>
                                    <div class="punch-det">
                                        <h6>Punch Out at</h6>
                                        <p>{{fdata.checkout}}</p>
                                    </div>
                                    <div class="statistics">
                                        <div class="row">
                                            <div class="col-md-6 col-6 text-center">
                                                <div class="stats-box">
                                                    <p>Break</p>
                                                    <h6>{{this.convertMinsToHrsMins(fdata.break_time)}} hrs</h6>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card recent-activity">
                                <div class="card-body">
                                    <h5 class="card-title">Activity</h5>
                                    <ul class="res-activity-list" v-if="fdata.activity_log">
                                        <li v-for="(activity, index) in fdata.activity_log.split(',')">
                                            <p class="mb-0" v-if="index % 2 == 0">Punch In at</p>
                                            <p class="mb-0" v-else>Punch Out at</p>
                                            <p class="res-activity-time">
                                                <i class="far fa-clock"></i>
                                                {{formateMe(activity) }}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 " v-else>
                Can not submit attendance for an ex employee.
            </div>
        </b-modal> -->
        <!-- <b-modal id="bv-modal-add-leave-profile" size="xl" scrollable  hide-footer title="Leave Details">
            <employee-leave-details v-if="this.employee_id > 0"  :editflg="0"  v-on:childToParent="reloadMe"></employee-leave-details>
        </b-modal> -->

    </div>
</template>

<script>
    import SearchEmployees from './SearchEmployees';
    import moment from 'moment';
    export default{

        mounted() {
            this.$refs.trzcalendar;

            //alert( moment().year() +'>>'+ moment().month());
        },
        props: ['flg' , 'is_profile'],
        components: {
            SearchEmployees
        },
        data(){
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const maxDate = new Date(today);
            maxDate.setMonth(maxDate.getMonth());

            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth());
            minDate.setDate(1);
            return {

                cu : window.location.href,
                ce : true,

                max: maxDate,
                min: minDate,
                successmsg:'',
                errormsg:[],
                fdata: {check_in: null, checkout:null , absent:0 , attendances_date:''},

                componentKey: 0,

                avatar_src : '',
                employee_name : '',
                date_of_birth : '',
                gender : '',
                employee_code : '',
                branch_name : '',
                employee_jobposition : '',
                employee_department : '',
                leave_policy : '',
                employee_email : '',
                employee_phone : '',

                dp_today : new Date(),

                weekly_holidays : [6],
                first_day_of_week : 7,
                this_month_holidays : [],
                week_holidays : [6],
                all_week_holidays : [6],
                holidays_date_arr : [],

                weekend_color_code : '#aaaaaa',
                holiday_color_code : '#aaaaaa',

                header_year_month : '',

                start_date: null,
                end_date: null,

                total_working_day : 0,
                total_weekends : 0,
                total_holidays : 0,
                total_absent : 0,
                total_leaves : 0,

                leavetypes : [],
                leave_available : [],

                leave_attendance_report : [],

                total_leaves_available : 0,
                total_leaves_remaining : 0,
                total_leaves_taken : 0,

                /*Aboni edit starts*/
                attendances:[],
                week_days_header:[],
                length_options: [],
                today_index : 0,
                attendances_date : null,

                check_in : null,
                checkout : null,
                work_time : 0,
                break_time : 0,
                over_time : 0,
                activity_log : null,

                attendances_date2 : null,

                check_in2 : null,
                checkout2 : null,
                work_time2 : 0,
                break_time2 : 0,
                over_time2 : 0,
                activity_log2 : null,

                edit_date : null,
                employee_id : 0,

                /*Aboni edit ends*/
                masks :
                    {
                        title: 'MMMM YYYY',
                        weekdays: 'W',
                        navMonths: 'MMM',
                        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                        dayPopover: 'WWW, MMM D, YYYY',
                        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                    },

                attributes: [
                        {
                            // AbdullahFixed commented this
                            // key: 'today',
                            // dot: 'pink',
                            dates: new Date(),
                        }
                    ],

                page: { month: '', year: '' },
                // AbdullahFixed added this
                doughnutDatas: null,
                options_doughnut:null,
                myStyles_doughnut:null,

            }
        },
        methods:{

            // AbdullahFixed added this
             monthDetailsNew: function(x='' , y=0, m=0)
            {
                let currentObj = this;
                let year = 0;
                let month = 0;

                if(y == 0)
                {
                    year = x['year'];
                    month = x['month'];
                }
                else
                {
                    year = y;
                    month = m;
                }

                //alert(year + ' ' + month);
                // let st_date = new Date(year , month-2, 1);
                // let en_date = new Date(year , month-1, 0);

                let st_date = new Date(year , month-2 , 1);
                let en_date = new Date(year , month , 0);

                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');


                // fetch holidays dynamically from controller
                axios.get(this.$api_url+'/employee/attendances/details' , {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then(function(response){

                    this.all_week_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10);});
                    this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function(item){ return item;});
                    this.weekly_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10) + 1;});
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;

                    this.this_month_holidays = response.data.holidays;

                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;
                    this.total_absent = response.data.report.absent;
                    this.total_leaves = response.data.report.total_leaves;

                    //this.$refs.trzcalendar;
                     // Abdullah: 12-05-2026
                    this.weekend_color_code = response.data.report.weekend_color_code;
                    this.holiday_color_code = response.data.report.holiday_color_code;
                    // Abdullah: 12-05-2026


                }.bind(this)).catch(function (error){ currentObj.serverError(error);});;

            },

            doughnutData(basic_salary,house_rent){
                this.doughnutDatas = {
                  labels: ['Approved Leaves', 'Allowed Leaves'],
                  datasets: [{
                    data: [basic_salary,house_rent],
                    borderColor: ['#76C9D3','#3A52A5'], // Add custom color border
                    backgroundColor: ['#76C9D3','#3A52A5'], // Add custom color background (Points and Fill)
                    borderWidth: 4 // Specify bar border width

                  }]
                };

                 this.options_doughnut= {
                    responsive: true, // Instruct chart js to respond nicely.
                    maintainAspectRatio: true, // Add to prevent default behaviour of full-width/height
                    cutoutPercentage: 85, // Add to prevent default behaviour of full-width/height
                    legend: {
                        display: false
                    },
                    tooltips: {
                        callbacks: {
                            title: function(tooltipItem, data) {
                                return data['labels'][tooltipItem[0]['index']];
                            },
                            label: function(tooltipItem, data) {
                                return data['datasets'][0]['data'][tooltipItem['index']].toLocaleString();
                            },
                        },
                    }


                };
                this.myStyles_doughnut={
                    width: '90%',
                    position: 'relative',


                };
            },


            // AbdullahFixed added upto this
            /*Aboni edit starts*/
            resetdata : function()
            {
                this.attendances_date = null;
                this.check_in = null;
                this.checkout = null;
                this.work_time = 0;
                this.break_time = 0;
                this.over_time = 0;
                this.activity_log = null;

                this.fdata = {};
            },
            reloadMe : function()
            {
                this.$bvModal.hide('bv-modal-add-leave-profile');
                this.getLeaveAttendanceReport();
                this.componentKey += 1;
            },
            convertMinsToHrsMins: function (minutes) {
                if(minutes){
                    var h = Math.floor(minutes / 60);
                    var m = minutes % 60;
                    h = h < 10 ? '0' + h : h;
                    m = m < 10 ? '0' + m : m;
                    return h + ':' + m;
                }else{
                    return '0:00';
                }
            },
            formateMe :function(minutes){
                return moment(minutes, "hh:mm").format('LT');
            },

            /*Aboni edit ends*/
            canEdit: function()
            {
                axios.get(this.$api_url+'/canedit' , {
                    params: {

                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            dateDisabled(ymd, date) {

                const x = moment(String(date)).format('YYYY-MM-DD');
                const weekday = date.getDay();
                const day = date.getDate();
                return this.all_week_holidays.includes(weekday) || this.holidays_date_arr.includes(x);
            },
            showSerch: function(){
                this.$bvModal.show('bv-modal-employeesearch');
            },
            helloFars(value)
            {
                this.canEdit();
                //alert(value.employee_id);
                this.employee_id = value.employee_id;
                this.$forceUpdate();

                this.$bvModal.hide('bv-modal-employeesearch');

                let y = moment().year();
                let m = moment().month();
                m += 1;

                this.page = { month: '', year: '' };
                this.monthDetails('' , y , m);

                this.getLeaveAttendanceReport();
                this.componentKey += 1;

            },
            addLeave()
            {
                this.$bvModal.show('bv-modal-add-leave-profile');
            },
            loadAttendance :function(day , ins)
            {
                /*if(day < this.min)return;
                alert(this.min);
                alert(day);*/
                //alert(day + ' >> ' + title);
                //fdata: {check_in: null, checkout:null , absent:0 , attendances_date:''},
                this.resetdata();

                if((ins.status == 'work') || (ins.status == 'absent'))
                {
                    this.fdata.absent = 0;
                    this.fdata.attendances_date = day;

                    this.fdata.absent = 0;
                    this.fdata.attendances_date = day;
                    if(ins.status == 'absent')
                    {
                        this.fdata.absent = 1;
                        this.fdata.check_in = null;
                        this.fdata.checkout = null;
                        this.fdata.comment = ins.comment;
                    }
                    else
                    {

                        this.fdata.check_in = ins.check_in;
                        this.fdata.checkout = ins.checkout;
                        this.fdata.comment = ins.comment;
                        this.fdata.work_time = ins.work_time;
                        this.fdata.break_time = ins.break_time;
                        this.fdata.over_time = ins.over_time;
                        this.fdata.activity_log = ins.activity_log;
                    }

                    this.$bvModal.show('attendance_edit_Modal');
                }
                else
                    return;



            },
            getLeaveAttendanceReport: function()
            {
                //leave_attendance_report
                if(!this.checkNet()) return false;

                axios.get(this.$api_url+'/leave/attendances/report/fiscalyear' , {
                    params: {

                    }
                }).then(function(response){

                    this.leave_attendance_report = response.data;

                     this.doughnutData(26, 36);

                }.bind(this));
            },


            getLeaveTypes: function()
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                axios.get(this.$api_url+'/leave/types?f=1' , {
                    params: {

                    }
                }).then(function(response){

                    this.leavetypes = response.data;

                }.bind(this));
            },
            monthDetails: function(x='' , y=0, m=0)
            {
                let currentObj = this;
                let year = 0;
                let month = 0;

                if(y == 0)
                {
                    year = x['year'];
                    month = x['month'];
                }
                else
                {
                    year = y;
                    month = m;
                }

                //alert(year + ' ' + month);

                let st_date = new Date(year , month - 1 , 1);
                let en_date = new Date(year , month , 0);


                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');

                // fetch holidays dynamically from controller
                axios.get(this.$api_url+'/employee/attendances/details' , {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then(function(response){

                    this.all_week_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10);});
                    this.holidays_date_arr = response.data.report.holidays_date_arr.split(',').map(function(item){ return item;});
                    this.weekly_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10) + 1;});
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;

                    this.this_month_holidays = response.data.holidays;

                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;
                    this.total_absent = response.data.report.absent;
                    this.total_leaves = response.data.report.total_leaves;

                    this.weekend_color_code = response.data.report.weekend_color_code;
                    this.holiday_color_code = response.data.report.holiday_color_code;

                    //this.$refs.trzcalendar;


                }.bind(this)).catch(function (error){ currentObj.serverError(error);});;

            },
            getEmployeeData()
            {

                let currentObj = this;
                axios.get(this.$api_url+'/employee/publicinfo' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                        this.avatar_src = this.$api_url+'/images/employee/'+ response.data.company_id + '/' + response.data.pic;
                        this.employee_id =  response.data.employee_id;
                        this.employee_name =  response.data.name;
                        this.date_of_birth =  response.data.date_of_birth;
                        this.gender =  response.data.gender;
                        this.employee_code =  response.data.employee_code;
                        this.branch_name =  response.data.branch_name;
                        this.employee_jobposition =  response.data.jobposition;
                        this.employee_department =  response.data.department;
                        this.leave_policy =  response.data.leave_policy;
                        this.employee_email =  response.data.email;
                        this.employee_phone =  response.data.phone;



                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/attendances', formData, config)
                                .then(function (response)
                                {
                                    //console.log(response.data);
                                    //window.location.href = this.$api_url;

                                    //window.location.href = this.$api_url;
                                    currentObj.$bvToast.toast('Attendance data saved.', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });

                                    this.$bvModal.hide('attendance_edit_Modal');

                                    let tempdate = this.fdata.attendances_date;
                                    var check = moment(tempdate, 'YYYY-MM-DD');

                                    var m = check.format('M');
                                    var y  = check.format('YYYY');
                                    this.monthDetails('',y,m);

                                    this.page = { month: m, year: y };

                                    this.getLeaveAttendanceReport();

                                }.bind(this))
                                .catch(function (error)
                                {

                                    currentObj.serverError(error);
                                });
                });
            },

        },
        created: function(){
            //
            this.canEdit();

            this.getEmployeeData();
            this.getLeaveTypes();

            this.getLeaveAttendanceReport();




        },
        computed:
        {
            fetchStartWeekday()
            {
                return parseInt(this.first_day_of_week) - 1;
            },
        }
    }
</script>
<style>
    .trz_borders {color: #ccc;}
</style>
